/* 18-09-2026: valuta-prefix voor niet-AUD-markten. Shopify formatteert de store-valuta
   als "A$99.95" maar presentment-valuta's als kaal "$124.95"; het formaat van die laatste
   is niet instelbaar. Dit script laadt alleen (zie theme.liquid) als de bezoeker in een
   andere markt zit en zet het prefix uit MAP voor elk kaal $-bedrag in tekstnodes,
   ook in later gerenderde delen (cart drawer, zoekresultaten, section rendering). */
(function () {
  var MAP = { NZD: 'NZ$', CAD: 'CA$' };
  var script = document.currentScript;
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || (script && script.dataset.currency);
  var prefix = MAP[cur];
  if (!prefix) return;
  var RE = /(^|[^A-Za-z])\$(?=\d)/g;
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, NOSCRIPT: 1, TEMPLATE: 1, SELECT: 1, OPTION: 1 };
  function fixText(node) {
    var t = node.data;
    if (t.indexOf('$') === -1) return;
    var n = t.replace(RE, function (m, lead) { return lead + prefix; });
    if (n !== t) node.data = n;
  }
  function fix(node) {
    if (node.nodeType === 3) { if (!SKIP[node.parentNode && node.parentNode.tagName]) fixText(node); return; }
    if (node.nodeType !== 1 || SKIP[node.tagName]) return;
    var w = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (SKIP[n.parentNode.tagName]) return NodeFilter.FILTER_REJECT;
        return n.data.indexOf('$') > -1 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var list = [];
    while (w.nextNode()) list.push(w.currentNode);
    list.forEach(fixText);
  }
  function start() {
    fix(document.body);
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var m = ms[i];
        if (m.type === 'characterData') fix(m.target);
        else for (var j = 0; j < m.addedNodes.length; j++) fix(m.addedNodes[j]);
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
